export default __webpack_public_path__ + "static/img_integrated-222d0aac5bff2249048086ff600fda8a.png";